import { Pipe, PipeTransform } from '@angular/core';
import { getInitials } from '@marmon/shared/types/user';

@Pipe({
	name: 'initials',
	standalone: true,
})
export class InitialsPipe implements PipeTransform {
	transform(name: string) {
		return getInitials(name);
	}
}
